import { IS_WIDGET } from '../../constants';

export const getIsWidget = () => IS_WIDGET;
